import React from 'react'
import { Translate } from 'react-localize-redux'

const renderPositionInGrid = (params) => {
  if (!params.row.position) {
    return null
  }

  return <Translate id={`player.${params.row.position}`} />
}

export default renderPositionInGrid

